var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:(this.getContainerStyle())},[_c('p',{style:(this.getTextStyle())},[_vm._v(_vm._s(_vm.letters))])])
}
var staticRenderFns = []

export { render, staticRenderFns }